export default __webpack_public_path__ + "static/image-45-ee5da625c1b411e3a79db3aa1e0cfa44.jpg";